import { Button } from "@/components/ui/button";
import { DialogClose, DialogFooter } from "@/components/ui/dialog";
import { Trash2 } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface ProjectSchedulesDeleteDialogFooterProps {
  disabled: boolean;
}

const ProjectSchedulesDeleteDialogFooterComponent = ({
  disabled,
}: ProjectSchedulesDeleteDialogFooterProps) => {
  const { t } = useTranslation();

  return (
    <DialogFooter>
      <DialogClose asChild>
        <Button variant="outline">{t("common.cancel")}</Button>
      </DialogClose>
      <Button type="submit" variant="destructive" disabled={disabled}>
        <Trash2 className="w-4 h-4" /> {t("common.delete")}
      </Button>
    </DialogFooter>
  );
};

export const ProjectSchedulesDeleteDialogFooter = memo(
  ProjectSchedulesDeleteDialogFooterComponent,
);
